'use client';
import React, { useState } from 'react';

interface Testimonial {
  id: number;
  name: string;
  location: string;
  text: string;
  rating: number;
  avatar: string;
  avatarAlt: string;
}

const testimonials: Testimonial[] = [
{
  id: 1,
  name: 'Arjun Malhotra',
  location: 'Hyderabad',
  text: '"Neo Capital Group is the ultimate destination to find your dream premium plot. As a premier residential plot company, they provide unparalleled service and expertise to help you discover your perfect investment. Trust Neo Capital Group to turn your dream of owning land into a reality."',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14a5ca983-1763300171126.png",
  avatarAlt: 'Portrait of Arjun Malhotra, satisfied Neo Capital Group customer from Hyderabad'
},
{
  id: 2,
  name: 'Deepika Iyer',
  location: 'Bangalore',
  text: '"I had an incredible experience with Neo Capital Group\'s Green Valley Phase-2! The premium plots are perfectly located, and the amenities are truly impressive. The sales team did an excellent job showcasing the project and guiding through the entire process. Highly recommend!"',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15de8827c-1763301545528.png",
  avatarAlt: 'Portrait of Deepika Iyer, happy premium plot investor from Bangalore'
},
{
  id: 3,
  name: 'Karthik Subramanian',
  location: 'Chennai',
  text: '"I bought a premium plot in Neo Capital Group\'s Turmeric Valley a few months ago, and it has quickly become one of the best properties in my portfolio. Neo Capital Group delivered exactly as promised, and I couldn\'t be more satisfied with their service."',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f683e81c-1763296551731.png",
  avatarAlt: 'Portrait of Karthik Subramanian, premium plot investor from Chennai'
},
{
  id: 4,
  name: 'Meenakshi Balasubramaniam',
  location: 'Pune',
  text: '"Proud to be a part of the Neo Capital Group customer family. I truly appreciate their commitment and service, from helping us understand the project to ensuring we receive the registration documents promptly. Excellent transparency throughout."',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15de8827c-1763301545528.png",
  avatarAlt: 'Portrait of Meenakshi Balasubramaniam, satisfied premium plot buyer from Pune'
},
{
  id: 5,
  name: 'Rohit Deshmukh',
  location: 'Mumbai',
  text: '"We recently acquired a premium plot in Neo Capital Group\'s Spice Garden community, and we\'re thoroughly impressed with the venture and amenities offered. From the scenic views to the top-notch facilities, our experience has been exceptional."',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1318fe91d-1763293685242.png",
  avatarAlt: 'Portrait of Rohit Deshmukh, premium plot investor from Mumbai'
}];


export default function TestimonialsSection() {
  const [activePage, setActivePage] = useState(0);
  const itemsPerPage = 3;
  const totalPages = Math.ceil(testimonials.length / itemsPerPage);
  const visibleTestimonials = testimonials.slice(activePage * itemsPerPage, activePage * itemsPerPage + itemsPerPage);

  return (
    <section id="testimonials" className="py-16 md:py-20 bg-brand-bg-light">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark font-avenir mb-3">
            What People Say
          </h2>
          <hr className="border-0 h-0.5 bg-brand-green w-20 mx-auto mb-4" />
          <p className="text-brand-gray font-avenir text-sm max-w-xl mx-auto">
            Neo Capital Group has earned customer trust through transparent processes, legally approved plot developments, and professionally planned layouts designed for long-term investment value.
          </p>
        </div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          {visibleTestimonials.map((testimonial) =>
          <div
            key={testimonial.id}
            className="bg-white rounded-2xl p-6 shadow-card hover:shadow-card-hover transition-shadow duration-300 flex flex-col">
            
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) =>
              <svg key={i} className="w-4 h-4 text-brand-turmeric" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
              )}
              </div>

              {/* Quote */}
              <p className="text-brand-gray font-avenir text-sm leading-relaxed flex-1 mb-4">
                {testimonial.text}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-brand-turmeric/20">
                <img
                src={testimonial.avatar}
                alt={testimonial.avatarAlt}
                className="w-10 h-10 rounded-full object-cover border-2 border-brand-turmeric/30" />
              
                <div>
                  <div className="text-brand-dark font-semibold font-avenir text-sm">{testimonial.name}</div>
                  <div className="text-brand-gray-light font-avenir text-xs">{testimonial.location}</div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Pagination Dots */}
        <div className="flex justify-center gap-2">
          {Array.from({ length: totalPages }).map((_, index) =>
          <button
            key={index}
            onClick={() => setActivePage(index)}
            className={`transition-all duration-300 rounded-full ${
            index === activePage ?
            'w-8 h-3 bg-brand-turmeric' : 'w-3 h-3 bg-brand-gray-light/40 hover:bg-brand-turmeric/50'}`
            }
            aria-label={`Page ${index + 1}`} />

          )}
        </div>
      </div>
    </section>);

}